import { usePendingHook } from '../../hooks';
import { MixerLoader } from '../Common';

interface IProps {
    type: string;
    children: React.ReactNode;
    onLoading?: React.ReactNode;
    overlayLoader?: boolean;
}
export const Loader = ({ type, onLoading = <MixerLoader position="centerOnScreen" />, children }: IProps) => {
    const isPending = usePendingHook(type);
    return (
        <>
            {isPending && onLoading}
            {children}
        </>
    );
};
